<template>
  <div class="moMenuBox">
    <page-menu />
    <div class="userInfoBox">
      <div class="tips">
        <img :src="head" alt="祝你开心每一天！" />
        <h3>{{ welcomeSrc }}祝你开心每一天！</h3>
      </div>
      <div class="numBox">
        <div class="numLeft numContent">
          <p>工厂数量</p>
          <h3>{{ total }}</h3>
        </div>
        <div class="numLeft numContent">
          <p>配方数量</p>
          <h3>{{ formulaCount }}</h3>
        </div>
        <div class="numContent">
          <p>产品数量</p>
          <h3>{{ productCount }}</h3>
        </div>
      </div>
    </div>
    <div class="notice">
      <a-row>
        <a-col :span="2">
          <img
            style="height: 18px"
            src="../../assets/images/notice.svg"
            alt=""
          />
        </a-col>
        <a-col :span="20">
          <a-carousel
            dot-position="left"
            autoplay
            :dots="false"
            style="width: calc(100% - 100px);height:20px"
          >
            <template v-if="noticeList.length">
              <div v-for="item in noticeList" :key="item.id" class="nv">
                <a v-if="item.content" target="_blank" :href="item.content">
                  {{ item.title }}</a
                >
                <h3 v-else>
                  {{ item.title }}
                </h3>
              </div>
            </template>

            <span v-else>暂无平台公告</span>
          </a-carousel>
        </a-col>
        <a-col
          :span="2"
          style="text-align: right; cursor: pointer"
          @click="jump"
        >
          <span style="padding: 0 8px 0 0">{{ noticeList.length }}条公告</span>
          <a-icon type="right" />
        </a-col>
      </a-row>
    </div>
    <div class="factoryListBox">
      <div style="display: flex; justify-content: space-between">
        <img
          style="height: 25px"
          src="../../assets/images/myFactory.svg"
          alt=""
        />
        <a-input-search
          style="width: 270px"
          v-model="searchKey"
          placeholder="输入工厂名称"
          @search="getFactory"
          @change="getFactory"
        >
        </a-input-search>
      </div>
      <a-row class="factoryCardBox" :gutter="30">
        <a-col
          v-for="el in list"
          :key="el.sort"
          @click="joinFactory(el)"
          :xs="24"
          :sm="24"
          :md="12"
          :lg="8"
          :xl="8"
          :xxl="6"
        >
          <div class="factoryCard">
            <div class="factoryCardContent">
              <img :src="headPortrait" :alt="el.name" />
              <div class="factory-content">
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    {{ el.name }}
                  </template>
                  <h3>{{ el.name }}</h3>
                </a-tooltip>
                <div style="display: flex">
                  <a-tooltip placement="topLeft">
                    <template slot="title"> 工厂编号：{{ el.code }} </template>
                    <p style="margin: 0 15px 0 0">工厂编号：{{ el.code }}</p>
                  </a-tooltip>
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      我的配方：{{ el.formulaTotal }}
                    </template>
                    <p>我的配方：{{ el.formulaTotal }}</p>
                  </a-tooltip>
                </div>
              </div>
            </div>
            <p class="joinBtn">进入工厂</p>
          </div>
        </a-col>
      </a-row>
      <!-- <div class="toggle-map" >
        <div>
          <a-input-search size="large" style="width:300px" placeholder="请输入工厂名称" v-if="listType == 0" @search="searchKey => getFactory({searchKey})" :allowClear="true" />
        </div>
        <a-radio-group size="small" button-style="solid" v-model="listType">
          <a-radio-button :value="index" v-for="(item,index) in ['unordered-list','global']" :key="index">
            <a-icon :type="item" />
          </a-radio-button>
        </a-radio-group>
      </div> -->
      <div class="paginationBox">
        <a-pagination
          style="float: right; margin-top: 10px"
          show-size-changer
          v-model="current"
          :show-total="(total) => `共${total}条记录`"
          :total="total"
          :pageSize="pageSize"
          @change="onChange"
          @showSizeChange="onShowSizeChange"
          :pageSizeOptions="pageSizeOptions"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
// import FactoryMap from "./FactoryMap.vue";
// import FactoryList from './FactoryList.vue';
import PageMenu from '../Home/PageMenu.vue'
export default {
  // components: { FactoryMap, FactoryList },
  components: { PageMenu },
  data() {
    return {
      list: [],
      searchKey: '',
      pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
      headPortrait: require("../../assets/images/card.png"),
      head: require("../../assets/images/head.png"),
      code: "",
      welcomeSrc: "",
      formulaCount: 0,
      listType: 1,
      productCount: 0,
      total: 0,
      current: 1,
      pageSize: 0,
      userInfo: {},
      clientInfo: {},
      noticeList: [],
    };
  },
  computed: {
    pageSizeC() {
      let pageSize = window.localStorage.getItem('factoryListPageSize')
      let pageSizeC = pageSize ? Number(pageSize) : 20
      return pageSizeC
    },
  },
  created() {
    let accessToken = window.localStorage.getItem("accessToken");
    let refreshToken = window.localStorage.getItem("refreshToken");
    if (accessToken && refreshToken) {
      this.getFactory();
      this.getUserInfo();
      setTimeout(() => {
        let user = window.localStorage.getItem('userInfo')
        // this.userInfo = this.setUserInfo(user)
        if (user) {
          this.$track.sendTrack('login', {
            userInfo: this.setUserInfo(JSON.parse(user))
          })
        }
      }, 1000);
    } else {
      this.$router.push("/login");
    }
  },
  mounted() {
    this.getClient()
  },
  methods: {
    setUserInfo(data) {
      let { userId, userName, email, code: userNo, userType, phoneNumber, clientId, } = data || {}
      return { userName, userId, email, userNo, userType, phoneNumber, clientId, }
    },
    async getClientList() {
      let params = {
        current: 1,
        size: 5,
        clientId: this.clientInfo.id
      }
      let res = await this.$get('/iot-factory/basicNotice/page', params)
      let { success, data } = res || {}
      if (success) {
        let { records } = data;
        this.noticeList = records || []
      }
    },
    async getClient() {
      let params = {
        pageSize: 1,
        size: 1000,
      }
      let res = await this.$get('/iot-system/client/list', params)
      let { success, data } = res || {}
      if (success) {
        this.clientInfo = data.records.find(el => el.clientName == 'NHF');
        this.getClientList()
      }
    },
    onChange(current, pageSize) {
      this.current = current;
      this.pageSize = pageSize;
      this.getFactory();
    },
    onShowSizeChange(current, pageSize) {
      this.current = current;
      this.pageSize = pageSize;
      window.localStorage.setItem('factoryListPageSize', pageSize)
      this.getFactory();
    },

    getUserInfo() {
      this.$http.get("/nhf-app/formulaManage/myFormulaInfo").then(res => {
        let { success, data } = res;
        if (success) {
          let { userInfo, formulaCount, productCount } = data;
          this.formulaCount = formulaCount || 0;
          this.productCount = productCount || 0;
          let today = new Date();
          let todayTime = today.getTime();
          let todayDate = moment(today).format("YYYY-MM-DD");
          let src1 = new Date(todayDate + " 06:00:00").getTime();
          let src2 = new Date(todayDate + " 08:00:00").getTime();
          let src3 = new Date(todayDate + " 11:00:00").getTime();
          let src4 = new Date(todayDate + " 13:00:00").getTime();
          let src5 = new Date(todayDate + " 18:00:00").getTime();
          let name = userInfo.userName ? userInfo.userName + "，" : "";
          this.$store.commit("saveUserName", { userName: userInfo.userName });
          window.localStorage.setItem("userName", userInfo.userName);
          this.code = userInfo.code || "";
          if (todayTime < src1) {
            this.welcomeSrc = `凌晨好，${name}`;
          } else if (todayTime >= src1 && todayTime < src2) {
            this.welcomeSrc = `早上好，${name}`;
          } else if (todayTime >= src2 && todayTime < src3) {
            this.welcomeSrc = `上午好，${name}`;
          } else if (todayTime >= src3 && todayTime < src4) {
            this.welcomeSrc = `中午好，${name}`;
          } else if (todayTime >= src4 && todayTime < src5) {
            this.welcomeSrc = `下午好，${name}`;
          } else if (todayTime >= src5) {
            this.welcomeSrc = `晚上好，${name}`;
          }
        } else {
          this.$message.error("查询失败");
        }
      });
    },

    joinFactory(record) {
      window.localStorage.setItem('overseasFlag', record.overseasFlag)
      window.localStorage.setItem("factoryId", record.factoryId);
      window.localStorage.setItem("factory", JSON.stringify(record));
      window.localStorage.setItem("factoryName", record.name);
      this.$store.commit("saveFactoryName", { factoryName: record.name });
      this.$router.push("/mainPage");
    },

    jump() {
      this.$router.push("/notice");
    },

    async getFactory(arg = {}) {
      let params = {
        current: this.current,
        size: this.pageSize ? this.pageSize : this.pageSizeC,
        ...arg,
        searchKey: this.searchKey
      };
      const res = await this.$http.get("/nhf-app/formulaManage/myFactory", { params })
      let { success, data } = res;
      if (success) {
        let { records, current, total, size } = data;
        this.list = records || [];
        this.pageSize = size
        this.current = current;
        this.total = total;
      } else {
        this.$message.error("查询失败");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle-map {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  right: 20px;
  left: 20px;
  padding: 20px 0;
  top: 0;
  z-index: 10;
}
h3,
p {
  margin: 0;
  padding: 0;
  font-size: 13px;
}
.moMenuBox {
  height: calc(100vh - 80px);
  overflow: hidden;

  .numBox {
    display: flex;
    align-items: center;
    .numLeft:after {
      content: "";
      border-right: 1px solid rgba(233, 233, 233, 1);
      display: block;
      position: absolute;
      right: 0;
      width: 1px;
      top: 10px;
      bottom: 10px;
    }
    .numContent {
      position: relative;
      text-align: center;
      padding: 0 30px;
      h3,
      p {
        margin: 0;
        padding: 0;
        font-size: 13px;
      }
      h3 {
        font-size: 28px;
        color: #444;
        font-weight: 800;
      }
    }
  }

  .notice {
    margin: 20px 20px 0;
    background: white;
    padding: 14px 20px 14px;
    border-radius: 5px;
  }
  width: 100%;
  .userInfoBox {
    position: relative;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    img {
      width: 44px;
      height: 44px;
      margin-right: 10px;
    }
  }
  .tips {
    display: flex;
    align-items: center;
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 16px;
    }
  }
  .factoryListBox {
    height: calc(100vh - 170px);
    overflow: hidden;
    position: relative;
    background: #fff;
    margin: 20px 20px 0;
    background: white;
    padding: 20px 20px 0px;
    border-radius: 5px;
  }
  .factoryCardBox {
    margin-top: 20px;
    overflow-y: auto;
    height: calc(100% - 180px);
    z-index: 90;
  }

  .factoryCard {
    background-color: #fff;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    transition: 0.5s;
    margin-bottom: 20px;
    border: 1px solid #c3c3c3;
    position: relative;
    &:hover {
      // box-shadow: 0 12px 40px rgba(80, 80, 80, 0.1);
      // transform: translateY(-12px);
    }
    &:hover .joinBtn {
      visibility: visible;
      display: block;
    }
    .factoryCardContent {
      padding: 20px 20px 26px;
      display: flex;
      .factory-content {
        width: calc(100% - 70px);
        flex: 1;
      }
      h3 {
        font-weight: bold;
        margin-bottom: 10px;
        font-size: 19px;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      p {
        font-size: 14px;
        font-weight: normal;
        margin-bottom: 3px;
        color: #888;
      }
      img {
        width: 66px;
        height: 66px;
        margin-right: 15px;
      }
    }
  }
  .joinBtn {
    width: 100%;
    text-align: center;
    height: 34px;
    line-height: 34px;
    background-color: #f7f9fa;
    color: #009dff;
    // background: rgba($color: #000000, $alpha: 0.3);
    // color: #fff;
    margin-bottom: 0;
    position: absolute;
    bottom: 0;
    cursor: pointer;
    // visibility: hidden;
    display: none;
  }
}
.factoryPagination {
  text-align: right;
  margin-top: 20px;
  padding-right: 20px;
  // text-indent: 20px;
}
.paginationBox {
  // box-shadow: 0 -1px 3px 3px rgba(0,0,0,0.1);
  // height: 80px;
  border-top: 1px solid #fff;
}

.nv {
  a{
    color: #333;
  }
  a:hover {
    color: #1677ff !important;
  }
}
</style>
